const formatTimelineTimestamp = (value: number) => {
  const totalSeconds = Math.max(0, Math.round(value))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

const rightRoundedRectPath = (
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
) => {
  const clampedRadius = Math.max(0, Math.min(radius, height / 2, width))
  if (clampedRadius === 0) {
    return `M ${x} ${y} H ${x + width} V ${y + height} H ${x} Z`
  }
  return [
    `M ${x} ${y}`,
    `H ${x + width - clampedRadius}`,
    `Q ${x + width} ${y} ${x + width} ${y + clampedRadius}`,
    `V ${y + height - clampedRadius}`,
    `Q ${x + width} ${y + height} ${x + width - clampedRadius} ${y + height}`,
    `H ${x}`,
    'Z',
  ].join(' ')
}

const roundedBarPath = (
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
  roundLeft: boolean,
  roundRight: boolean,
) => {
  const maxRadius = Math.max(0, Math.min(radius, height / 2, width / 2))
  const left = roundLeft ? maxRadius : 0
  const right = roundRight ? maxRadius : 0
  return [
    `M ${x + left} ${y}`,
    `H ${x + width - right}`,
    right
      ? `Q ${x + width} ${y} ${x + width} ${y + right}`
      : `L ${x + width} ${y}`,
    `V ${y + height - right}`,
    right
      ? `Q ${x + width} ${y + height} ${x + width - right} ${y + height}`
      : `L ${x + width} ${y + height}`,
    `H ${x + left}`,
    left
      ? `Q ${x} ${y + height} ${x} ${y + height - left}`
      : `L ${x} ${y + height}`,
    `V ${y + left}`,
    left ? `Q ${x} ${y} ${x + left} ${y}` : `L ${x} ${y}`,
    'Z',
  ].join(' ')
}

export { formatTimelineTimestamp, rightRoundedRectPath, roundedBarPath }
